// The Playground's start screen: one column and one decision, shown while
// there's no lesson, no request and no response. Take a lesson, start from a
// real question, or write your own; each opens the request and response side
// by side. See Design > Console.

import { ChoiceRow, List } from "../../../../ui/src/index.ts";
import { LIMITS } from "../../domain/request.ts";
import { LessonList, UseCaseList } from "../lessons.tsx";
import { useStore } from "../store.ts";
import { ExamplesNote } from "../ui.tsx";
import { BLANK_STARTS } from "./RequestPanel.tsx";

const BLANKS = [
  { title: "One question", text: "Ask every hub that knows the subject one question.", start: () => BLANK_STARTS.question() },
  { title: "Several questions", text: `Send up to ${LIMITS.questions} questions in one request.`, start: BLANK_STARTS.questions },
  { title: "Only certain hubs", text: "Ask one question of the hubs you name.", start: BLANK_STARTS.hubs },
];

export function Start() {
  const lessons = [...useStore((s) => s.content.lessons)].sort((a, b) => a.number - b.number);
  const useCases = useStore((s) => s.content.useCases);
  const examples = useStore((s) => s.examples);
  return (
    <div class="cs-start">
      <div class="cs-intro">
        <h2>Try a request</h2>
        <p>Send a question to the hubs and see exactly what your code would get back: the answer, its sources and what it cost.</p>
      </div>
      <section class="cs-home-section">
        <div class="cs-home-section__head"><div><h2>Take a lesson</h2><p>Five short lessons. Each sends a real request and explains what came back.</p></div></div>
        {lessons.length === 0 ? <ExamplesNote examples={examples} /> : <LessonList lessons={lessons} />}
      </section>
      {useCases.length > 0 && <section class="cs-home-section">
        <div class="cs-home-section__head"><div><h2>Start from a real question</h2><p>Opens it with a bid that gets an answer. Change anything before you send it.</p></div></div>
        <UseCaseList useCases={useCases} />
      </section>}
      <section class="cs-home-section">
        <div class="cs-home-section__head"><div><h2>Write your own</h2><p>Start from an empty request and fill it in.</p></div></div>
        <List>
          {BLANKS.map((b) => (
            <ChoiceRow key={b.title} title={b.title} sub={b.text} onSelect={b.start} />
          ))}
        </List>
      </section>
    </div>
  );
}
